export default __webpack_public_path__ + "static/data_w.2164a676761c8ba404c2e5673622bcf9.svg";